import AboutWebApp from './about_web_app'
export default AboutWebApp